module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    ref: "pdfviewer",
    staticClass: "common_pdfviewer_wrapper",
    attrs: {
      "title": _vm.title === '' ? 'PDF Viewer' : _vm.title,
      "visible": _vm.visible,
      "close": _vm.handleClose,
      "top": "80px",
      "width": "1100px"
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('div', {
    staticClass: "maincontent"
  }, [_c('div', {
    staticClass: "header"
  }, [(!!_vm.download) ? _c('el-button', {
    on: {
      "click": _vm.handleDownloadFile2
    }
  }, [_vm._v(_vm._s(_vm.$t('btn.download')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "main",
    class: {
      download: !!_vm.download
    }
  }, [_c('div', {
    staticClass: "operator"
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "icon": "el-icon-arrow-left",
      "disabled": _vm.atBegining
    },
    on: {
      "click": _vm.handlePrevious
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('canvas', {
    style: (_vm.canvasStyle),
    attrs: {
      "id": "the-canvas"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "operator"
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "icon": "el-icon-arrow-right",
      "disabled": _vm.atEnd
    },
    on: {
      "click": _vm.handleNext
    }
  })], 1)]), _vm._v(" "), (_vm.pagination.limit > 1) ? _c('div', {
    staticClass: "footer"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 1,
      "total": _vm.pagination.limit,
      "current-page": _vm.pagination.page
    },
    on: {
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pagination, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pagination, "page", $event)
      },
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3a0a285a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a0a285a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/libs/PDFViewer/PDFViewer.vue
// module id = 1562
// module chunks = 7